// extracted by mini-css-extract-plugin
export default {"container":"gDJT","tab":"xeC_","activeTab":"OGoA"};